import type { IOnboardingImagesSearchQuery } from '@/types/onboarding.types';
import { ref } from 'vue';

export const sortByOnboarding = ref<null | string>('created');
export const sortOrderOnboarding = ref<null | string>('DESC');
export const paginationOnboarding = ref<null | string>('true');
export const pageOnboarding = ref<null | string>('true');

export const query = ref<IOnboardingImagesSearchQuery>({});
